<template>
  <div>
    <v-form
      class="mt-7"
      v-model="valid"
      ref="invitationForm"
      @submit.prevent="inviteReviewer"
    >
      <v-row>
        <v-col cols="4">
          <v-select
            :items="titles"
            outlined
            label="Title *"
            :rules="rules.required"
            v-model="invitation.title"
          ></v-select>
        </v-col>
        <v-col cols="8">
          <v-text-field
            outlined
            label="First Name *"
            :rules="rules.required"
            v-model="invitation.firstName"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-text-field
        outlined
        label="Last Name *"
        :rules="rules.required"
        v-model="invitation.lastName"
      ></v-text-field>

      <v-combobox
        v-model="invitation.institution"
        :items="institutions"
        item-text="name"
        item-value="name"
        label="Institution name *"
        outlined
        :return-object="false"
        :rules="rules.required"
      ></v-combobox>

      <v-text-field
        outlined
        label="Department / College *"
        :rules="rules.required"
        v-model="invitation.department"
      ></v-text-field>

      <v-text-field
        outlined
        label="Specialization (optional)"
        v-model="invitation.specialization"
      ></v-text-field>

      <v-text-field
        outlined
        label="Email *"
        :rules="rules.required"
        v-model="invitation.email"
      ></v-text-field>

      <v-text-field
        outlined
        label="Phone number (optional)"
        v-model="invitation.phone"
      ></v-text-field>

      <v-divider class="mb-7"></v-divider>

      <v-textarea
        outlined
        clearable
        v-model="invitation.note"
        label="Additional note (optional)"
      >
      </v-textarea>

      <div>
        <p class="mb-7">* mark required fields.</p>
        <v-btn
          color="blue"
          type="submit"
          class="white--text mr-2"
          :disabled="!valid || inviting"
          :loading="inviting"
        >
          Invite Reviewer
        </v-btn>
      </div>
    </v-form>

    <div v-if="invitations.length > 0">
      <v-divider class="mt-7"></v-divider>
      <h3 class="text-center my-4">External invites already sent</h3>

      <v-card
        flat
        v-for="invite in invitations"
        :key="invite._id"
        color="yellow lighten-5"
        class="my-3 pa-3"
      >
        <p class="d-flex">
          <v-spacer></v-spacer>
          <v-chip
            small
            outlined
            class="white--text"
            :color="invite.active ? 'green' : 'brown'"
            >{{ invite.active ? "ACTIVE" : "INACTIVE/CANCELLED" }}</v-chip
          >
        </p>
        <p>
          {{ invite.title }} {{ invite.firstName }} {{ invite.lastName }} of
          <u>{{ invite.department }}</u
          >, <u>{{ invite.institution }}</u>
          <span v-if="invite.specialization">
            specializing in <u>{{ invite.specialization }}</u></span
          >&nbsp;was invited on {{ formatDateOnly(invite.createdAt) }}
        </p>
        <p>{{ invite.email }} | {{ invite.phone }}</p>
        <v-btn
          block
          depressed
          class="red--text"
          color="red lighten-4"
          v-if="invite.active"
          :disabled="cancelling"
          :loading="cancelling"
          @click="cancelExternalInvitation(invite._id)"
        >
          Cancel External Invite
        </v-btn>
      </v-card>
    </div>
  </div>
</template>

<script>
import { required } from "../../../tools/rules";
import { formatDateOnly } from "../../../tools/format";
import { USER_TITLES } from "../../../tools/specs";
import Institutions from "../../../data/world_universities_and_domains-min.json";

export default {
  props: {
    manuscript: { type: String },
  },

  data: () => ({
    valid: false,
    rules: {
      required,
    },

    email: null,
    inviting: false,
    cancelling: false,

    invitation: {
      title: "",
      firstName: "",
      lastName: "",
      institution: "",
      department: "",
      specialization: null,
      email: "",
      phone: "",
      note: null,
    },

    titles: USER_TITLES,
    institutions: Institutions,
    invitations: [],
  }),

  methods: {
    formatDateOnly,
    inviteReviewer() {
      this.inviting = true;
      this.$axios
        .post("/invites", {
          ...this.invitation,
          ...{ manuscript: this.manuscript },
        })
        .then(() => {
          this.$bus.$emit("snackbar", {
            type: "success",
            message: "Reviewer invitation sent",
          });
          this.$emit("invited");
          this.$refs.invitationForm.reset();
          this.manuscriptReviewerInvites();
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message:
              "Could not invite reviewer, email may already exist on system",
          });
        })
        .finally(() => {
          this.inviting = false;
        });
    },
    manuscriptReviewerInvites() {
      this.$axios
        .get(`/invites/manuscript/${this.manuscript}`)
        .then(({ data: response }) => {
          this.invitations = response;
        })
        .finally(() => {
          this.inviting = false;
        });
    },
    cancelExternalInvitation(id) {
      this.cancelling = true;

      this.$axios
        .put(`/invite/cancel/${id}`)
        .then(() => {
          this.$bus.$emit("snackbar", {
            type: "warning",
            message: "Invitation cancelled",
          });

          this.manuscriptReviewerInvites();
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not cancel invitation",
          });
        })
        .finally(() => {
          this.cancelling = false;
        });
    },
  },

  mounted() {
    this.manuscriptReviewerInvites();
  },
};
</script>

<style>
</style>